import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=ab2d54b4&"
import script from "./PaymentHistory.vue?vue&type=script&lang=js&"
export * from "./PaymentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports